import type { ReactNode } from 'react';

import { connect } from 'react-redux';
import type { Facet, OverrideValues, AccommodationState, RatingFacet } from '@/interfaces';
import { actions } from '@/state/filterActions';
import { fetchHotels } from '@/ducks/searchResults/actions';
import { type CheckboxDispatchProps, CheckboxFilter, type CheckboxStateProps } from '@/components/checkboxFilter/CheckboxFilter';
import type { ActionCreator } from 'redux';
import { StarRating } from '@/components/starRating/StarRating';

export const mapStarRatings = (starRatings: readonly RatingFacet[]): readonly Facet[] =>
    starRatings
        .filter((rating) => rating.key > 0)
        .sort((a, b) => b.key - a.key)
        .map((rating) => ({ value: rating.key.toString(), count: rating.value }));

export const displayValues: Record<string, ReactNode> = {
    '1': <StarRating id="StarRatingFilter-1" rating={1} />,
    '2': <StarRating id="StarRatingFilter-2" rating={2} />,
    '3': <StarRating id="StarRatingFilter-3" rating={3} />,
    '4': <StarRating id="StarRatingFilter-4" rating={4} />,
    '5': <StarRating id="StarRatingFilter-5" rating={5} />,
};

export const mapStateToProps = (state: AccommodationState): CheckboxStateProps => ({
    id: 'StarRatingFilter',
    label: 'Hotellstandard',
    facetList: mapStarRatings(state.searchResults.starRatings),
    displayValues: displayValues,
    checkboxValues: state.filters.starRating,
    hideLabel: true,
    alwaysExpanded: true,
});

export const mapDispatchToProps: OverrideValues<CheckboxDispatchProps, ActionCreator<unknown>> = {
    checkBoxClick: actions.filterStarRating,
    triggerFetch: fetchHotels,
};

export default connect(mapStateToProps, mapDispatchToProps)(CheckboxFilter);
